import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=de5ca4da&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=js&"
export * from "./UserPage.vue?vue&type=script&lang=js&"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=de5ca4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5ca4da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de5ca4da')) {
      api.createRecord('de5ca4da', component.options)
    } else {
      api.reload('de5ca4da', component.options)
    }
    module.hot.accept("./UserPage.vue?vue&type=template&id=de5ca4da&scoped=true&", function () {
      api.rerender('de5ca4da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/UserPage.vue"
export default component.exports